import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx } from "vue";
import { defineAsyncComponent, computed } from "vue";
export default /*#__PURE__*/ _defineComponent(Object.assign({ inheritAttrs: false }, { __name: 'UIIcon', props: {
        name: {}
    }, setup(__props) {
        const props = __props;
        const classes = computed(() => (["UIIcon", `UIIcon--${props.name}`]));
        const icon = computed(() => {
            const name = props.name;
            if (name) {
                return defineAsyncComponent(() => import(`@/assets/icons/${name}.svg`));
            }
            return null;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Suspense, null, {
                fallback: _withCtx(() => [
                    _createElementVNode("span", _mergeProps({ class: classes.value }, _ctx.$attrs), null, 16)
                ]),
                default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), _mergeProps({ class: classes.value }, _ctx.$attrs), null, 16, ["class"]))
                ]),
                _: 1
            }));
        };
    } }));
